export const MuiDivider = {
  defaultProps: {
    color: ' #d8dee4'
  }
}
